import { makeStyles } from "@material-ui/core";


export default makeStyles((theme) => ({
    header: {
        backgroundColor: theme.palette.common.white,
        height: 68,
    },
    title: {
        flexGrow: 1,
    },
}));
